import {Badge} from "@chakra-ui/react";
import type {RiskRating, FindingRating, EvaluationScore} from "../../types";
import {riskRatingConfig, findingRatingConfig, evaluationScoreConfig} from "./ratingConfig";

export function RiskRatingBadge({rating, size = "sm"}: {rating: RiskRating; size?: "sm" | "md"}) {
  const config = riskRatingConfig[rating];
  return (
    <Badge
      bg={config.bg}
      color={config.color}
      px={size === "sm" ? 2 : 3}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="600"
      textTransform="none"
    >
      {config.label}
    </Badge>
  );
}

export function FindingRatingBadge({rating, size = "sm"}: {rating: FindingRating; size?: "sm" | "md"}) {
  const config = findingRatingConfig[rating];
  return (
    <Badge
      bg={config.bg}
      color={config.color}
      px={size === "sm" ? 2 : 3}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="600"
      textTransform="none"
    >
      {config.label}
    </Badge>
  );
}

export function EvaluationBadge({score}: {score: EvaluationScore}) {
  if (score === null) {
    return (
      <Badge
        bg="gray.100"
        color="gray.500"
        px={2}
        py={0.5}
        borderRadius="md"
        fontSize="xs"
        fontWeight="600"
        textTransform="none"
      >
        Not Assessed
      </Badge>
    );
  }
  const config = evaluationScoreConfig[score];
  return (
    <Badge
      bg={config.bg}
      color={config.color}
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="600"
      textTransform="none"
    >
      {config.label}
    </Badge>
  );
}
